import { Row, Input,} from "antd";
import { useState, useEffect } from "react";
import { } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
export const InputHome = ({
  tipo,
  idCampo,
  nombreCampo,
  elValue,
  elPlaceholder,
  required,
  tipoError,
  error,
  onChange,
}) => {
  const [value, setValue] = useState();
  const [showPassword, setShowPassword] = useState(false);
    // Función para alternar la visibilidad de la contraseña
    const togglePasswordVisibility = () => {
      setShowPassword(!showPassword);
    };
  
  // console.log("onChange prop:", onChange)
  let esRequired = required ? "*" : "";

  useEffect(() => {
    setValue(elValue !== "" ? elValue : undefined);
  }, [elValue]);
  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setValue(value); // Actualiza el estado local con el nuevo valor
    onChange({ target: { value: value, id: id } }); // Simula un evento y pasa el nuevo valor a la función onChange
  };
  return (
    <Row justify={"left"}
        style={{ padding: 10, display: "flex", flexDirection: "column", width: "100%", minWidth: "auto" }}>
      <label htmlFor={idCampo}>
        <p className="nombre-campo">
          {nombreCampo} {esRequired}
        </p>
      </label>
      {tipo === "textarea" ? (
        <textarea
          id={idCampo}
          name={idCampo}
          value={elValue}
          onChange={onChange}
          placeholder={typeof elPlaceholder === "string" ? elPlaceholder : undefined}
          style={{
            width: "100%",
            height: "150px",
            padding: "10px",
            borderRadius: "10px",
            borderColor: "#d9d9d9",
            fontFamily: "Roboto Condensed",
            fontSize: "1.5em",
            boxSizing: "border-box"
          }}
        />
      ) : (
        <Input
          className="input-home"
          autoComplete="none"
          id={idCampo}
          type={tipo === "password" && showPassword ? "text" : tipo}
          placeholder={typeof elPlaceholder === "string" ? elPlaceholder : undefined}
          onChange={handleInputChange}
          value={value}
          required={required}
          status={tipoError}
          suffix={
            tipo === "password" && (
              <span
                onClick={togglePasswordVisibility}
                style={{ cursor: "pointer" }}
              >
                {showPassword ? <EyeTwoTone /> : <EyeInvisibleOutlined />}
              </span>
            )
          }
        />
      )}
      <span className="spanErrores" style={{ color: "red" }}>
        <b>{error}</b>
      </span>
    </Row>
  );
};
